import styled from 'styled-components';
import JobReviewDetail from './component';

export default styled(JobReviewDetail)`
  background-color: var(--grey500);
  flex: 1;
  overflow: hidden auto;

  .header {
    width: 100%;
    background: var(--grey100);
  }

  .driver {
    background-color: white;
    width: 100%;
    min-height: 80px;
    display: flex;
    align-items: center;
    padding: 0 24px;

    &__name {
      font-size: 16px;
      font-weight: bold;
    }
    &__carrier_name {
      font-size: 14px;
    }
    .container {
      flex: 1;
    }
  }

  .reasons {
    padding: 0 24px 24px 24px;
    width: 100%;
    background-color: white;
    display: flex;
    .reason {
      margin-right: 16px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .error {
    background-color: var(--error100);
    color: var(--error900);
    font-weight: bold;
    padding: 16px;
  }

  .success {
    background-color: var(--success100);
    color: var(--success900);
    font-weight: bold;
    padding: 16px;
  }

  .close_button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: #fff;
    text-decoration: none;
    font-size: 1.4rem;
    text-transform: uppercase;
    line-height: normal;
    background-color: var(--primary);
    &:hover {
      cursor: pointer;
      background-color: var(--900);
    }
  }
`;
